define('responsive-gameday/views/Monitor/ViewModels/distributors/PlayByPlayViewDistributor',['require','exports','module','GameDayCore','jquery','../../../distributors/viewDistributors/ViewDistributorBase','../../Events/ViewModelUpdateEvents','message-service/message-service','../../../distributors/events/DistributionEvents','extant/extant','gameday-resource-path/gameday-resource-path','GameDayCore/GDModel/enums/baseball/GameStates'],function(require,exports,module) {
    var GDC = require("GameDayCore"),
        $ = require("jquery"),
        ViewDistributorClass = require("../../../distributors/viewDistributors/ViewDistributorBase"),
        UpdateEvents = require("../../Events/ViewModelUpdateEvents"),
        MessageService = require("message-service/message-service"),
        DistEvents = require("../../../distributors/events/DistributionEvents"),
        exists = require("extant/extant"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        GameStates = require("GameDayCore/GDModel/enums/baseball/GameStates");

    var Superclass;

    function PlayByPlayViewDistributor(evt) {
        this.eventType = evt;
        Superclass.constructor.call(this,evt);

        // MessageService.addListener.call(this, DistEvents.UPDATE_ALL, this.refresh);
        MessageService.addListener.call(this, UpdateEvents.REQUEST_PLAYBYPLAY_DATA, this.handleUpdateRequest);
    }

    ViewDistributorClass.spawn(PlayByPlayViewDistributor).define({
        prepDataForView: function() {
            this.dataPack = {
                linescore : this.game.boxscore.linescore,
                teams     : {
                    home: this.game.game.home,
                    away: this.game.game.away
                }
            };
            this.dispatchUpdates();
        },
        handleUpdateRequest : function(){
            this.game = GDC.getGameData();
            this.prepDataForView();
        }
    });

    Superclass = PlayByPlayViewDistributor.superclass;

    return PlayByPlayViewDistributor;
});

